import client from './client'
import type { CrowdTask, CrowdTaskListResponse, CrowdAssignment } from '../types'

export async function listAvailableTasks(skip = 0, limit = 20, lang?: string): Promise<CrowdTaskListResponse> {
  const res = await client.get('/v1/crowd/tasks/', { params: { skip, limit, ...(lang ? { lang } : {}) } })
  return res.data
}

export async function getTaskDetail(taskId: string, lang?: string): Promise<CrowdTask> {
  const res = await client.get(`/v1/crowd/tasks/${taskId}`, { params: lang ? { lang } : {} })
  return res.data
}

export async function claimTask(taskId: string): Promise<CrowdAssignment> {
  const res = await client.post(`/v1/crowd/tasks/${taskId}/claim`)
  return res.data
}

export async function abandonTask(taskId: string): Promise<void> {
  await client.post(`/v1/crowd/tasks/${taskId}/abandon`)
}

export async function getMyAssignments(): Promise<CrowdAssignment[]> {
  const res = await client.get('/v1/crowd/tasks/my')
  return res.data
}

export async function getAssignmentDetail(assignmentId: string): Promise<CrowdAssignment> {
  const res = await client.get(`/v1/crowd/tasks/my/${assignmentId}`)
  return res.data
}

export async function completeAssignment(assignmentId: string): Promise<void> {
  await client.post(`/v1/crowd/submissions/assignments/${assignmentId}/complete`)
}
